import type { RootState } from '@/_store/store';

export const selectSelectedDeliveryId = (state: RootState) =>
  state.deliveries.selectedDeliveryId;
